import React, { useMemo } from 'react';
import { useContext } from '../utils/useContext';
import { Context as CartContext } from './Cart';
import { Context as OptimisticContext } from './Optimistic';
export const useCart = () => {
    const cart = useContext(CartContext);
    const optimistic = React.useContext(OptimisticContext);
    return useMemo(() => ({ ...cart, isValidating: Boolean(optimistic) }), [cart, optimistic]);
};
//# sourceMappingURL=useCart.js.map